/**
 *
 * @param {object} previousData The existing stream information saved in the system.
 * @param {object} updatedData The updated form data for the stream.
 * @returns {object} An object containing the properties with updates to send to the mutation.
*/
export const getUpdates = (previousData, updatedData) => {
  const updates = {};
  const streamProperties = [
    'name',
    'description',
    'useInterleavedRTSPTransport',
    'pullOnRequest',
    'snapshotInterval',
    'sourceId',
    'applianceId',
    'zoneId',
  ];
  streamProperties.forEach((prop) => {
    switch (prop) {
      case 'useInterleavedRTSPTransport':
        if (previousData.use_interleaved_rtsp_transport !== updatedData.stream.rtspInterleaved) {
          updates[prop] = updatedData.stream.rtspInterleaved;
        }
        break;
      case 'pullOnRequest':
        if (previousData.pull_on_request !== updatedData.stream.onDemand) {
          updates[prop] = updatedData.stream.onDemand;
        }
        break;
      case 'snapshotInterval':
        if (previousData.snapshot_interval !== updatedData.stream.snapshotInterval) {
          updates[prop] = updatedData.stream.snapshotInterval !== '' ? updatedData.stream.snapshotInterval : null;
        }
        break;
      case 'sourceId':
        if(previousData.source.id !== updatedData.source.id) {
          updates[prop] = updatedData.source.id;
        }
        break;
      case 'applianceId':
        if(previousData.appliance.id !== updatedData.appliance.id) {
          updates[prop] = updatedData.appliance.id;
        }
        break;
      case 'zoneId':
        if(previousData.zone.id !== updatedData.zone.id) {
          updates[prop] = updatedData.zone.id;
        }
        break;
      default:
        if (previousData[prop] !== updatedData.stream[prop]) {
          updates[prop] = updatedData.stream[prop];
        }
        break;
    }
  });

  return updates;
};